import { Typography } from '../Typography/Typography.js';
import { getPageStyles } from './PageStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Page = _ref => {
  let {
    children,
    onClick,
    ariaLabel,
    selected = false,
    disabled = false,
    selectable = true,
    withIcon = false,
    ...rest
  } = _ref;
  return jsx(Typography, {
    bold: true,
    variant: "body2",
    component: "button",
    onClick: onClick,
    "aria-label": ariaLabel,
    disabled: disabled || selected,
    "aria-current": selected ? 'step' : undefined,
    css: getPageStyles({
      selected,
      disabled,
      selectable,
      withIcon
    }),
    ...rest,
    children: children
  });
};

export { Page };
//# sourceMappingURL=Page.js.map
